<template>
    <v-card width="100%" :style="hoverBackgroundCard" class="myprovet-shortcut-card mx-auto" @mouseenter="mouseEnter()" @mouseleave="mouseLeave()" @click="shortcutClick">
        <div>
            <v-card-title class="white--text pt-4 pb-3">
                <v-icon left dark class="shortcut-title-icon">
                    {{ userCustomShortcuts.icon }}
                </v-icon>

                <span :class="titleFontSize" class="font-weight-bold">{{ getCustomShortcutName }}</span>
            </v-card-title>

            <v-card-text class="white--text pb-1">
                <span :class="descriptionFontSize" class="white--text font-weight-light">{{ tb(userCustomShortcuts.description) }}</span>
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        userCustomShortcuts: Object,
    },

    computed: {
        hoverBackgroundCard() {
            if (this.hovering) {
                return `background: linear-gradient(0deg, rgba(21, 69, 121, 0.4), rgba(21, 69, 121, 0.4)), url(${this.userCustomShortcuts.image})`;
            }

            return `background: linear-gradient(0deg, rgba(21, 69, 121, 0.6), rgba(21, 69, 121, 0.6)), url(${this.userCustomShortcuts.image})`;
        },

        titleFontSize() {
            switch (this.$vuetify.breakpoint.name) {
            case 'lg':
                return 'font-size-lg';
            case 'xl':
                return 'font-size-xl';
            default:
                return '';
            }
        },

        descriptionFontSize() {
            switch (this.$vuetify.breakpoint.name) {
            case 'lg':
                return 'font-size-md';
            case 'xl':
                return 'font-size-lg';
            default:
                return '';
            }
        },

        statisticsFontSize() {
            switch (this.$vuetify.breakpoint.name) {
            case 'lg':
                return 'font-size-sm';
            case 'xl':
                return 'font-size-md';
            default:
                return '';
            }
        },

        getCustomShortcutName() {
            // Makes this computed depend on the locale, so the title is recomputed when it changes
            this.$i18n.locale;

            if (this.userCustomShortcuts.name == 'Detalhes') return this.tb('Campanhas');
            return this.tb(this.userCustomShortcuts.name);
        },
    },

    data() {
        return {
            hovering: false,
        };
    },

    methods: {
        mouseEnter() {
            this.hovering = true;
        },

        mouseLeave() {
            this.hovering = false;
        },

        shortcutClick() {
            this.$inertia.visit(this.userCustomShortcuts.url);
        },
    },
};
</script>

<style scoped>
.myprovet-shortcut-card {
    /* background: linear-gradient(0deg, rgba(21, 69, 121, 0.6), rgba(21, 69, 121, 0.6)), url(/storage/assets/shortcuts/order.jpg); */
    background-size: cover !important;
    background-position: center !important;
    border-radius: 16px !important;
    cursor: pointer !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.myprovet-shortcut-card:hover {
    /* background: linear-gradient(0deg, rgba(21, 69, 121, 0.4), rgba(21, 69, 121, 0.4)), url(/storage/assets/shortcuts/order.jpg); */
    background-size: cover !important;
    background-position: center !important;
    border-radius: 16px !important;
    cursor: pointer !important;
}

.shortcut-title-icon {
    width: 40px;
    height: 40px;
    background: rgba(17, 162, 220, 0.35);
    /*background: #006DB6;*/
    border-radius: 8px;
}
</style>
